/* eslint-disable complexity */
import React from 'react';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { FaRegEye, FaPencilAlt } from 'react-icons/fa';
import { UButtonTypes } from '@exxonmobil/uit-uda-ui-components-lib';
import { Button } from 'antd';
import moment from 'moment';

import { DateTimeFormat } from 'config/const';
import { MODE } from 'models/baselines';
import { BaselineItemProps } from '../Baselines.types';
import { BaselineItemTotals } from '../BaselineItemTotals/BaselineItemTotals';
import useBaselineItem from '../BaselineItem/BaselineItem.hooks';
import { BaselineItemDetailsView } from '../BaselineItemDetailsView';
import { BaselineItemDetailsEdit } from '../BaselineItemDetailsEdit';
import styles from './BaselineItem.module.scss';

export const BaselineItem = ({
  baseline,
  isUserApprover,
  onCheckboxClickHandler,
  onIconClickHandler
}: BaselineItemProps) => {
  const { id, workCenter, description, approved, requested, mode, isSelected } =
    baseline;

  const {
    requestedState,
    approvedState,
    companyDropdownList,
    companyDropdownValue,
    contextHolder,
    isSubmitDisabled,
    totalDay,
    totalNight,
    hasRequested,
    addNewRange,
    updateShift,
    updateDate,
    onExpandRowHandler,
    onSubmitClickHandler,
    onCancelClickHandler,
    onAddCompanySelectHandler
  } = useBaselineItem({
    id,
    workCenter,
    requested,
    approved,
    onIconClickHandler
  });

  return (
    <div
      data-testid="itemContainer"
      className={
        mode === MODE.VIEW || mode === MODE.EDIT
          ? styles.baselineItemActive
          : styles.baselineItem
      }
    >
      {contextHolder}
      {mode === MODE.NONE && (
        <div
          data-testid="toExpand"
          role="button"
          tabIndex={0}
          onClick={() => {
            onIconClickHandler(MODE.VIEW, workCenter);
          }}
          onKeyDown={() => onIconClickHandler(MODE.VIEW, workCenter)}
          aria-label="button"
          className={styles.baselineItemExpander}
        />
      )}
      {mode === MODE.EDIT && (
        <div className={styles.editBaselineButtons}>
          <Button
            data-testid="submit"
            type={UButtonTypes.PRIMARY}
            onClick={onSubmitClickHandler}
            disabled={isSubmitDisabled}
          >
            SUBMIT
          </Button>
          <Button
            data-testid="cancel"
            type={UButtonTypes.PRIMARY}
            onClick={onCancelClickHandler}
          >
            CANCEL
          </Button>
        </div>
      )}
      <div>
        <div className={styles.checkboxContainer}>
          {hasRequested && isUserApprover && (
            <Checkbox
              data-testid="checkBox"
              checked={isSelected}
              onClick={() => onCheckboxClickHandler(!isSelected, workCenter)}
            />
          )}
        </div>
        <FaRegEye
          data-testid="eyeBtn"
          className={mode === MODE.VIEW ? styles.iconActive : styles.icon}
          onClick={() => {
            return mode === MODE.VIEW
              ? onIconClickHandler(MODE.NONE, workCenter)
              : onIconClickHandler(MODE.VIEW, workCenter);
          }}
        />
        <FaPencilAlt
          data-testid="pencilBtn"
          className={mode === MODE.EDIT ? styles.iconActive : styles.icon}
          onClick={() => {
            return mode === MODE.EDIT
              ? onIconClickHandler(MODE.NONE, workCenter)
              : onIconClickHandler(MODE.EDIT, workCenter);
          }}
        />
        <div>
          <h1 className={styles.name}>{workCenter}</h1>
        </div>
        <div>
          <h1 className={styles.area}>{description}</h1>
        </div>
        <div>
          {mode === MODE.VIEW && (
            <BaselineItemDetailsView
              approvedPeriods={approvedState}
              onExpandRowHandler={onExpandRowHandler}
            />
          )}
          {mode === MODE.EDIT && (
            <BaselineItemDetailsEdit
              approvedPeriods={approvedState}
              requestedPeriods={requestedState}
              workCenter={workCenter}
              companyDropdownList={companyDropdownList}
              companyDropdownValue={companyDropdownValue}
              addNewRange={addNewRange}
              updateShift={updateShift}
              updateDate={updateDate}
              onExpandRowHandler={onExpandRowHandler}
              onAddCompanySelectHandler={onAddCompanySelectHandler}
            />
          )}

          {(mode === MODE.NONE || mode === undefined) && (
            <div className={styles.baselineItemTotal}>
              <div>
                <h1 className={styles.date}>
                  {approvedState.length > 0 &&
                    moment(approved[0].from).format(DateTimeFormat.DatePicker)}
                </h1>
              </div>
              <div>
                <h1 className={styles.date}>
                  {approvedState.length > 0 &&
                    moment(approved[0].to).format(DateTimeFormat.DatePicker)}
                </h1>
              </div>
              <BaselineItemTotals
                total={{ day: totalDay, night: totalNight }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
